// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3X-SP","right":"styles_right__A1v-y"};